const selectors = {
  dancersList: (state) => state.dancers.dancersList,
  dancersListLoaded: (state) => state.dancers.dancersListLoaded,
  filters: (state) => state.dancers.filters,
  pagination: (state) => state.dancers.pagination,

  loadingListStatus: (state) => state.dancers.loadingListStatus,
};

export { selectors };
